import { ChangeDetectorRef, Component, effect, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { SettingsService } from 'src/app/shared/services/settings';
import { environment } from 'src/environments/environment';
import { ConversationService } from 'src/app/shared/services/conversation/conversation.service';

import * as _ from 'lodash';
import { NgIf, NgClass } from '@angular/common';
import { LitmusIntractionQuestionnaireComponent } from './sub-components/litmus-intraction-questionnaire/litmus-intraction-questionnaire.component';
// import { CreateNewQuestionComponent } from './sub-components/create-new-question/create-new-question.component';
import { LitmusIntractionPagesComponent } from './sub-components/litmus-intraction-pages/litmus-intraction-pages.component';
import { LitmusIntractionLanguagesComponent } from './sub-components/litmus-intraction-languages/litmus-intraction-languages.component';
import { LitmusIntractionGroupsComponent } from './sub-components/litmus-intraction-groups/litmus-intraction-groups.component';
import { LitmusIntractionNavigationComponent } from './sub-components/litmus-intraction-navigation/litmus-intraction-navigation.component';
import { LitmusIntractionCustomComponent } from './sub-components/litmus-intraction-custom/litmus-intraction-custom.component';
import { LitmusIntractionOffersComponent } from './sub-components/litmus-intraction-offers/litmus-intraction-offers.component';
import { LitmusIntractionCampaignComponent } from './sub-components/litmus-intraction-campaign/litmus-intraction-campaign.component';
import { LitmusIntractionDraftComponent } from './sub-components/litmus-intraction-draft/litmus-intraction-draft.component';
import { LtmsLoaderComponent } from '../../../../shared/components/ltms-loader/ltms-loader.component';
import { LitmusIntractionPreviewComponent } from './sub-components/litmus-intraction-preview/litmus-intraction-preview.component';
import { CanComponentDeactivate } from 'src/app/guards/can-deactivate.guard';

@Component({
  selector: 'app-project-interaction-settings-home',
  templateUrl: './project-interaction-settings-home.component.html',
  styleUrls: ['./project-interaction-settings-home.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    LitmusIntractionQuestionnaireComponent,
    // CreateNewQuestionComponent,
    LitmusIntractionPagesComponent,
    LitmusIntractionLanguagesComponent,
    LitmusIntractionGroupsComponent,
    LitmusIntractionNavigationComponent,
    LitmusIntractionCustomComponent,
    LitmusIntractionOffersComponent,
    LitmusIntractionCampaignComponent,
    LitmusIntractionDraftComponent,
    LtmsLoaderComponent,
    LitmusIntractionPreviewComponent

  ]
})
export class ProjectInteractionSettingsHomeComponent implements OnInit, CanComponentDeactivate {
  // Tab management
  activeTab: string = 'questions';
  tabList: any = ['questions', 'new_questions', 'pages', 'languages', 'groups', 'header', 'footer', 'navigation', 'custom', 'offers', 'campaign', 'draft']
  brandDetails: any = {}
  configuration: any = {}
  previewDevice = 'phone';
  isSaving = false;
  isPublishing = false;

  configurationLoaded: boolean = false;
  isDynamicPropertiesEnabled: boolean = false;
  dynamicPropertiesGroups: any = [{
    label: "Access Group",
    value: "access_group"
  }, {
    label: "Question Group",
    value: "question_group"
  }]

  tabVisblity: any = {
    questions: false,
    new_questions: false,
    pages: false,
    languages: false,
    groups: false,
    navigation: false,
    custom: false,
    draft: false,
  }
  isSaveEnabled = false;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private stateService: AppStateService,
    private _settingsService: SettingsService,
    private _conversation: ConversationService
  ) {
    effect(() => {
      if (this.stateService.initialized()) {
        const managerId: string = _.get(Helpers, 'managerDetails.manager.email_address')
        const adminRulesDic = _.cloneDeep(Helpers?.adminRulesDic || {});
        this.updateTabVisblity(adminRulesDic); 
        if (true) {
          const brandDetail: any = this.stateService.brandDetails();
          this.configurationLoaded = false;
          if (!_.isEmpty(brandDetail)) {
            this.brandDetails = brandDetail;
            if (_.get(this.brandDetails, 'module_configuration_v2.studio.sub_modules.conversation.sub_modules.dynamic_properties.visible')) {
              this.isDynamicPropertiesEnabled = true;
            }
            this._settingsService.getFeedbackConfiguration(brandDetail._id).subscribe((response: any) => {
              if (response && response?.data?.code == 0 && _.has(response, 'data.brand_configuration')) {
                this.configuration = response.data.brand_configuration[0] || {}
                this._conversation.init(brandDetail, this.configuration).then(() => {
                  this.configurationLoaded = true
                })

              }
            })
          }
        } else {
          this.router.navigate(["message"], { queryParams: { status: '402' } });
        }

      }
    })
  }

  updateTabVisblity(adminRulesDic: any) {
    if (adminRulesDic && !_.isEmpty(adminRulesDic)) {
      if (adminRulesDic.CONVERSATION_MANAGE_CONVERSATION && !_.isEmpty(adminRulesDic.CONVERSATION_MANAGE_CONVERSATION) &&( adminRulesDic.CONVERSATION_MANAGE_CONVERSATION.write || adminRulesDic.CONVERSATION_MANAGE_CONVERSATION.read)) {
        this.tabVisblity.questions = true;
        this.tabVisblity.new_questions = true;
        this.tabVisblity.pages = true;
        this.tabVisblity.languages = true;
        this.tabVisblity.groups = true;
        this.tabVisblity.navigation = true;
      } else {
        this.tabVisblity.questions = false;
        this.tabVisblity.new_questions = true;
        this.tabVisblity.pages = false;
        this.tabVisblity.languages = false;
        this.tabVisblity.groups = false;
        this.tabVisblity.navigation = false;
      }

      if (adminRulesDic.CONVERSATION_MANAGE_PUBLISH && !_.isEmpty(adminRulesDic.CONVERSATION_MANAGE_PUBLISH) &&( adminRulesDic.CONVERSATION_MANAGE_PUBLISH.write || adminRulesDic.CONVERSATION_MANAGE_PUBLISH.read)) {
        this.tabVisblity.draft = true;
      } else {
        this.tabVisblity.draft = false;
      }
    }
  }

  ngOnInit(): void {
    const adminRulesDic = _.cloneDeep(Helpers?.adminRulesDic || {});
    this.updateTabVisblity(adminRulesDic);
    this.route.queryParams.subscribe((params: any) => {
      let tabName = (this.tabList.indexOf(params['active_tab']) >= 0) ? params['active_tab'] : "questions";
      if(!this.tabVisblity[tabName]) tabName = "questions";
      this.toggleTab(tabName)
      this.cdr.detectChanges();
    });
  }

  /**
   * Toggle between different tabs
   * @param tabName The name of the tab to activate
   */
  async toggleTab(tabName: string): Promise<void> {
    if (tabName === this.activeTab) return;

    const isUnsaved = this._conversation?.isSaveEnabled;

    if (isUnsaved) {
      const shouldLeave = await this.confirmDiscardChanges();

      if (!shouldLeave) return;
    }

    this.activeTab = tabName;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { active_tab: tabName },
      queryParamsHandling: 'merge'
    });
  }

  showTopControl(){
    const excludedTabs:any = ['new_questions','draft','navigation','questions','languages','groups', 'pages']
    return (excludedTabs.indexOf(this.activeTab) < 0)
  }

  isCopied: boolean = false;
  copyToClipboard() {
    try {
      navigator.clipboard.writeText(this.getPreviewUrl(true));
      this.isCopied = true;
      Helpers.smallAlertBox('Success', 'Preview link copied to clipboard', 'success', 3000);
      setTimeout(() => {
        this.isCopied = false;
      }, 3000);
    } catch (error) {
      this.isCopied = false;
      Helpers.smallAlertBox('Error', 'Failed to copy preview link', 'error', 3000);
    }
  }

  getPreviewUrl(isCopy?: boolean) {
    var configVersion = this.configuration.version;
    var brandId = this.brandDetails._id;
    var configUrl = (this.brandDetails.conversation_config.feedbacks['url']) ?
      this.getConfigBaseUrl(this.brandDetails.conversation_config.feedbacks['url'], 'v2/') :
      environment.base_url;
    var url = configUrl + "preview-v2/" + brandId + "?config=" + configVersion;
    if (isCopy) {
      return url;
    } else {
      return url + "&device=" + this.previewDevice;
    }
  }

  getConfigBaseUrl(url: string, text_exclude: string) {
    return url.replace(text_exclude, '');
  }

  /**
   * Preview the conversation
   */
  previewConversation() {
    const previewUrl = this.getPreviewUrl();
    window.open(previewUrl, '_blank');
  }

  /**
   * Save the conversation configuration
   */
  saveConversation() {
    if (this.isSaving) return;

    this.isSaving = true;
    this._conversation.saveConversation(false).then(() => {
      this.isSaving = false
    })
    // console.log("configuration  >>>>>", this.configuration);
    // this._settingsService.updateQuestionnaire(this.brandDetails._id, this.configuration, false).subscribe({
    //   next: (response: any) => {
    //     if (response?.data?.code === 0) {
    //       Helpers.smallAlertBox('Success', 'Conversation saved successfully', 'success', 3000);
    //       this.configuration = response.data.brand_configuration[0];
    //     } else {
    //       Helpers.smallAlertBox('Error', 'Failed to save conversation', 'error', 3000);
    //     }
    //   },
    //   error: (error) => {
    //     console.error('Error saving conversation:', error);
    //     Helpers.smallAlertBox('Error', 'Failed to save conversation', 'error', 3000);
    //   },
    //   complete: () => {
    //     this.isSaving = false;
    //   }
    // });
  }

  /**
   * Publish the conversation
   */
  publishConversation() {
    if (this.isPublishing) return;

    this.isPublishing = true
    this._conversation.saveConversation(true).then(() => {
      this.isPublishing = false
    })
    // // Show confirmation dialog
    // Helpers.showConfirmationBox('Publish Conversation', 'Are you sure you want to publish this conversation? This will make it live for your customers.', (result: any) => {
    //   if (result) {
    //     this.isPublishing = true;
    //     this._settingsService.updateQuestionnaire(this.brandDetails._id, this.configuration, true).subscribe({
    //       next: (response: any) => {
    //         if (response?.data?.code === 0) {
    //           Helpers.smallAlertBox('Success', 'Conversation published successfully', 'success', 3000);
    //           this.configuration = response.data.brand_configuration[0];
    //         } else {
    //           Helpers.smallAlertBox('Error', 'Failed to publish conversation', 'error', 3000);
    //         }
    //       },
    //       error: (error) => {
    //         console.error('Error publishing conversation:', error);
    //         Helpers.smallAlertBox('Error', 'Failed to publish conversation', 'error', 3000);
    //       },
    //       complete: () => {
    //         this.isPublishing = false;
    //       }
    //     });
    //   }
    // });

  }

  updateQuestionnaire(questionnaire: any) {
    console.log("questionnaire  >>>>>", questionnaire);
  }
  questionModalEvent(event: any) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { active_tab: 'new_questions' },
      queryParamsHandling: 'merge'
    });
  }

  isPreviewModalOpen: boolean = false;
  showPreviewModal() {
    this.isPreviewModalOpen = true
  }

  onCLosePreviewModal() {
    this.isPreviewModalOpen = false
  }

  canDeactivate(): Promise<boolean> | boolean {
    // Check if there are unsaved changes
    const hasUnsavedChanges = this._conversation?.isSaveEnabled;
    if (hasUnsavedChanges) {
      return this.confirmDiscardChanges();
    }
    return true;
  }
  confirmDiscardChanges(): Promise<boolean> {
    return new Promise((resolve) => {
      Helpers.SmartMessageBox(
        {
          title: "You have reordered the rows",
          content: "To save your changes, please use the <b>Save</b> obutton at the top right of the page. Click Discard Changes to lose your edits and continue. Click Cancel to close this popup and keep editing.",
          buttons: [
            { text: "Cancel", type: "secondary", key: "Cancel" },
            { text: "Discard Changes", type: "primary", key: "Discard" }
          ]
        },
        (ButtonPressed: string) => {
          setTimeout(() => {
            if (ButtonPressed === "Discard") {
              this.isSaveEnabled = false;
              this._conversation.isSaveEnabled = this.isSaveEnabled;
              resolve(true);
            } else {
              resolve(false);
            }
          }, 50);
        }
      );
    });
  }
}
